import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Dropdown, Menu } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faArchive,
    faInboxOut,
    faTrash
} from "@fortawesome/pro-solid-svg-icons";
import { faEllipsisV } from "@fortawesome/pro-light-svg-icons";
import ConfirmButton from "../ConfirmButton";
import { inProgress } from "../../modules/wevos/constants";
import * as dashboard from "../../modules/dashboard";
import styles from "../../styles/components/TestOptionsMenu.css";

export function LaunchedTestTooltip() {
    return (
        <div className={`${styles.disabledMenuButton} ${styles.tooltip}`}>
            <FontAwesomeIcon className={styles.menuIcon} icon={faEllipsisV} />
            <span className={styles.tooltipText}>
                Cannot perform an action on a launched test.
            </span>
        </div>
    );
}

function OptionsMenuButton({ onClick }) {
    return (
        <div className={styles.menuButton} onClick={onClick}>
            <FontAwesomeIcon className={styles.menuIcon} icon={faEllipsisV} />
        </div>
    );
}
OptionsMenuButton.propTypes = {
    onClick: PropTypes.func
};

export function Item({ label, icon, onClick, className }) {
    return (
        <div className={`${styles.item} ${className}`} onClick={onClick}>
            <FontAwesomeIcon className={styles.menuItemIcon} icon={icon} />
            <span className={styles.menuItemLabel}>{label}</span>
        </div>
    );
}

Item.propTypes = {
    label: PropTypes.string.isRequired,
    icon: PropTypes.object.isRequired,
    onClick: PropTypes.func,
    className: PropTypes.string
};

export function DeleteItem({ wevo, onClick }) {
    const confirmTitle = (
        <span>
            Are you sure you want to delete <b>{wevo.name}</b>?
        </span>
    );
    const confirmDescription = `You are about to delete the test "${
        wevo.name
    }". This action is permanent and cannot be undone.`;
    return (
        <ConfirmButton
            onConfirm={onClick}
            onConfirmColor="error"
            onConfirmText="Delete"
            confirmTitle={confirmTitle}
            confirmDescription={confirmDescription}
        >
            <Item label="Delete" icon={faTrash} className={styles.delete} />
        </ConfirmButton>
    );
}

DeleteItem.propTypes = {
    onClick: PropTypes.func.isRequired,
    wevo: PropTypes.shape({
        name: PropTypes.string.isRequired
    })
};

export function renderMenu({ wevo, deleteWevo, archiveWevo, unarchiveWevo }) {
    return (
        <Menu className={styles.menu} selectable={false}>
            {!wevo.isArchived && (
                <Menu.Item className={styles.menuItem}>
                    <Item
                        label="Archive"
                        icon={faArchive}
                        onClick={archiveWevo}
                    />
                </Menu.Item>
            )}
            {wevo.isArchived && (
                <Menu.Item className={styles.menuItem}>
                    <Item
                        label="Unarchive"
                        icon={faInboxOut}
                        onClick={unarchiveWevo}
                    />
                </Menu.Item>
            )}
            <Menu.Item className={styles.menuItem}>
                <DeleteItem wevo={wevo} onClick={deleteWevo} />
            </Menu.Item>
        </Menu>
    );
}

function TestOptionsMenu({
    wevo,
    containerId,
    deleteWevo,
    archiveWevo,
    unarchiveWevo
}) {
    if (inProgress(wevo.status) && !wevo.isArchived) {
        return <LaunchedTestTooltip />;
    }

    return (
        <Dropdown
            trigger={["click"]}
            overlay={renderMenu({
                wevo,
                deleteWevo,
                archiveWevo,
                unarchiveWevo
            })}
            getPopupContainer={() => document.getElementById(containerId)}
        >
            <OptionsMenuButton />
        </Dropdown>
    );
}

function mapDispatchToProps(dispatch, props) {
    return {
        deleteWevo: () => dispatch(dashboard.deleteWevo(props.wevo)),
        archiveWevo: () => dispatch(dashboard.archiveWevo(props.wevo)),
        unarchiveWevo: () => dispatch(dashboard.unarchiveWevo(props.wevo))
    };
}

TestOptionsMenu.propTypes = {
    containerId: PropTypes.string.isRequired,
    wevo: PropTypes.shape({
        id: PropTypes.number.isRequired,
        status: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        isArchived: PropTypes.bool.isRequired
    }).isRequired
};

export default connect(
    null,
    mapDispatchToProps
)(TestOptionsMenu);



// WEBPACK FOOTER //
// ./src/components/Dashboard/TestOptionsMenu.js